import { Outlet, useParams } from "react-router";
import t from "@/lang/lang";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import {
  NavigationGroup,
  ProcessPage,
  ProcessPageMain,
  ProcessPageMainContent,
  ProcessPageMainHeader,
  ProcessPageSidebar,
  ProcessPageSidebarNavigation,
  ProcessSidebarTrigger,
  ProcessPageSkeleton,
} from "@/shared/bsm/core/process/components/ui/process-page";
import { LayoutDashboard } from "lucide-react";
import {
  DocumentIconCalculation,
  DocumentIconOffer,
  DocumentIconRequirement,
} from "@/services/backend/documents/components/document-icon";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { MainPageContent } from "@/routes/_components/main-page";
import { Alert403 } from "@/shared/components/alerts/alert-403";
import { Separator } from "@/shared/components/ui/separator";
import { BreadcrumbsToDocument } from "@/shared/bsm/core/process/components/ui/breadcrumbs-to-document";
import { StateWarning } from "@/services/backend/processes/components/state/state-warning";

export default function GFSRoute() {
  const { processId } = useParams();
  const {
    data: process,
    isLoading,
    error,
  } = useProcessesProcessShowQuery({
    id: processId ?? "",
  });
  const canAccess = useFeatureAuth("gsm.gfs");

  if (!canAccess) {
    return (
      <MainPageContent>
        <Alert403 />
      </MainPageContent>
    );
  }

  return (
    <ProcessPage>
      {isLoading && <ProcessPageSkeleton />}
      {error && <RTKQueryErrorAlert error={error} />}
      {process && (
        <>
          <ProcessPageSidebar className="pt-16">
            <ProcessPageSidebarNavigation groups={sidebarNavigation} />
          </ProcessPageSidebar>
          <ProcessPageMain className="pt-16">
            <ProcessPageMainHeader className="justify-between">
              <div className="flex items-center gap-2">
                <ProcessSidebarTrigger />
                <Separator orientation="vertical" className="mr-2 h-4" />
                <BreadcrumbsToDocument process={process} />
              </div>
              <StateWarning processId={process.id} />
            </ProcessPageMainHeader>
            <ProcessPageMainContent>
              <Outlet />
            </ProcessPageMainContent>
          </ProcessPageMain>
        </>
      )}
    </ProcessPage>
  );
}

const sidebarNavigation: NavigationGroup[] = [
  {
    label: t("Allgemein"),
    items: [{ label: t("Übersicht"), icon: LayoutDashboard, to: "overview" }],
  },
  {
    label: t("Meilensteine"),
    items: [
      {
        label: t("Bestandsaufnahme"),
        icon: DocumentIconRequirement,
        to: "assessments",
      },
      {
        label: t("Kalkulation"),
        icon: DocumentIconCalculation,
        to: "calculations",
      },
      { label: t("Angebot"), icon: DocumentIconOffer, to: "offers" },
    ],
  },
];
